// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-avatar-wrap {
    position: relative;
    display: inline-block;
    cursor: pointer;
}

.profile-avatar {
    width: 130px;
    height: 130px;
    object-fit: cover;
    border: 3px solid var(--color-border);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
    transition: opacity 0.15s ease;
}

.profile-avatar-wrap:hover .profile-avatar {
    opacity: 0.85;
}

.profile-avatar-edit {
    position: absolute;
    right: 4px;
    bottom: 4px;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: var(--bs-primary);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.9rem;
    border: 2px solid #fff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}`, "",{"version":3,"sources":["webpack://./src/assets/css/profile.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,qCAAqC;IACrC,0CAA0C;IAC1C,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,sBAAsB;IACtB,yCAAyC;AAC7C","sourcesContent":[".profile-avatar-wrap {\n    position: relative;\n    display: inline-block;\n    cursor: pointer;\n}\n\n.profile-avatar {\n    width: 130px;\n    height: 130px;\n    object-fit: cover;\n    border: 3px solid var(--color-border);\n    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);\n    transition: opacity 0.15s ease;\n}\n\n.profile-avatar-wrap:hover .profile-avatar {\n    opacity: 0.85;\n}\n\n.profile-avatar-edit {\n    position: absolute;\n    right: 4px;\n    bottom: 4px;\n    width: 34px;\n    height: 34px;\n    border-radius: 50%;\n    background: var(--bs-primary);\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.9rem;\n    border: 2px solid #fff;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
